export default __webpack_public_path__ + "static/media/Pickpocket's Armbands of the Smoldering Throne.cac3141f.jpg";